import { render, staticRenderFns } from "./KOLProductSendTables.vue?vue&type=template&id=77477c8a&"
import script from "./KOLProductSendTables.vue?vue&type=script&lang=js&"
export * from "./KOLProductSendTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports